import { Modal, Spinner, useToaster } from '@enterprise-ui/canvas-ui-react'
import { CATALOG_CONSTANTS } from '../../../constants/item-catalog-constants'
import { useState } from 'react'
import { MicroFrontend } from '@praxis/component-microfrontend'
import apiConfig from '../../../config'
import { useNavigate } from 'react-router-dom'
import '../../../styles/itemCatalog.scss'
// TODO: Switch back to item-component Overlay post canvas 8 migration
// import { Overlay } from "item-component/canvas8"
import Overlay from '../../../components/Overlay'

// Defined outside the hook to prevent remounting the MFE on every state change
const UploadModalContent = ({
  isUploadModalOpen,
  isOverlayOpen,
  childModalOpen,
  uploadMfeConfig,
  navigate,
  onRefuse,
  handleActionComplete,
  setChildModalOpen,
  setIsOverlayOpen,
}) => (
  <>
    {/* TODO: Consume ContentModalLauncher & Overlay from item-component post canvas 8 migration */}
    <Modal
      headingText={CATALOG_CONSTANTS.BULK_UPLOAD.LABEL}
      size="md"
      isVisible={isUploadModalOpen}
      onRefuse={onRefuse}
    >
      <MicroFrontend
        src={uploadMfeConfig}
        module="./uploadStandard"
        Loading={() => (
          <Spinner
            size="lg"
            longWaitAriaAlert={
              CATALOG_CONSTANTS.BULK_UPLOAD.MESSAGE_LOADING_UPLOAD_MFE
            }
          />
        )}
        isEmbedded={true}
        clientScope="lpsearch"
        navigate={navigate}
        handleActionComplete={handleActionComplete}
        onChildModalVisibilityChange={setChildModalOpen}
        onActionInProgress={setIsOverlayOpen}
      />
    </Modal>
    {isOverlayOpen && (
      <Overlay
        showSpinner={false}
        longWaitAriaAlert={
          CATALOG_CONSTANTS.BULK_UPLOAD.MESSAGE_UPLOAD_ACTION_PROGRESS
        }
      />
    )}
  </>
)

export const useUploadMfe = () => {
  const [isUploadModalOpen, setIsUploadModalOpen] = useState(false)
  const [isOverlayOpen, setIsOverlayOpen] = useState(false)
  const [childModalOpen, setChildModalOpen] = useState(false)

  const uploadMfeConfig = `${apiConfig.remotes.bulkX}/remoteEntry.js`

  const navigate = useNavigate()
  const makeToast = useToaster()

  //Maintaining a separate function to handle the upload click, so that we can add any additional logic in future if needed like analytics and for readability.
  const handleUploadClick = () => {
    setIsUploadModalOpen(true)
  }

  const handleToastLinkClick = (event, link) => {
    const linkPath = link?.path
    if (!linkPath) {
      if (typeof link?.onClick === 'function') {
        event.preventDefault()
        link.onClick()
      }
      return
    }
    event.preventDefault()
    window.location.assign(linkPath)
  }

  const handleActionComplete = (payload) => {
    const variant = payload?.type || payload?.variant
    const toastLinks = payload?.links ?? []
    const message = (
      <>
        {payload?.message}
        {toastLinks.length > 0 &&
          toastLinks.map((link, index) => (
            <a
              key={link.path ?? index}
              href={link.path}
              onClick={(e) => handleToastLinkClick(e, link)}
              className="toast-link font-weight-500"
            >
              {link.text}
            </a>
          ))}
      </>
    )
    try {
      makeToast?.({
        // variant,
        type: variant, //TODO: Uncomment the above "variant" and remove this type post canvas 8 migration.
        heading: payload?.heading,
        message,
      })
    } catch (e) {
      console.error('Error showing toast', e)
    }
    setIsUploadModalOpen(false)
    setIsOverlayOpen(false)
  }

  const uploadModal = (
    <UploadModalContent
      isUploadModalOpen={isUploadModalOpen}
      isOverlayOpen={isOverlayOpen}
      childModalOpen={childModalOpen}
      uploadMfeConfig={uploadMfeConfig}
      navigate={navigate}
      onRefuse={() => {
        if (childModalOpen || isOverlayOpen) return
        setIsUploadModalOpen(false)
      }}
      handleActionComplete={handleActionComplete}
      setChildModalOpen={setChildModalOpen}
      setIsOverlayOpen={setIsOverlayOpen}
    />
  )

  return { handleUploadClick, uploadModal }
}
